import { ReactNodeArray, ReactNode } from 'react'
import Styles from './Card.module.scss'
import cx from 'classnames'
import { ProfileHeader } from './ProfileHeader'

interface Props {
  coverImage: ReactNode
  profileImage: ReactNode
  children: ReactNodeArray | ReactNode
  className?: string
}

export const Card = ({ coverImage, profileImage, children, className, ...props }: Props) => (
  <div {...props} className={cx(Styles.wrapper, className)}>
    <div className={Styles.header}>
      <ProfileHeader coverImage={coverImage} profileImage={profileImage} />
    </div>
    <div className={Styles.content}>{children}</div>
  </div>
)
